// extracted by mini-css-extract-plugin
export default {"form":"ProfileSettings_form__F5nNk","buttonRow":"ProfileSettings_buttonRow__SAvDQ"};